(function () {
  "use strict";

  mfManageUsers.$inject = ['gridFormatters', '$timeout', '$window'];
  angular
    .module('trainerWebApp.directives')
    .directive('mfManageUsers', mfManageUsers);

  function mfManageUsers(gridFormatters, $timeout, $window) {
    return {
      restrict: 'A',
      link: function (scope, iElement, iAttrs) {

        var gridColumns = [
          {
            id: "name",
            name: "Last, First",
            field: "name",
            minWidth: 200,
            cssClass: "cell-title",
            headerCssClass: "header-column",
            sortable: true
          },
          {id: "email", name: "Email", field: "email", minWidth: 200, headerCssClass: "header-column", sortable: true}
        ];

        if (scope.isUsernameEnabled) {
          gridColumns.push({
            id: "username",
            name: "Username",
            field: "username",
            minWidth: 80,
            headerCssClass: "header-column",
            sortable: true
          });
        }

        if (scope.roleVisible) {
          gridColumns.push({
            id: "permissions",
            name: "Role",
            field: "roleName",
            minWidth: 80,
            headerCssClass: "header-column",
            sortable: true
          });
        }

        scope.gridInfo = {
          options: {
            editable: false,
            enableCellNavigation: false,
            asyncEditorLoading: false,
            enableColumnReorder: false,
            forceFitColumns: true,
            forceSyncScrolling: scope.gridData.length < 500,
            multiColumnSort: true
          },
          highlightRowsEnabled: true,
          columns: gridColumns,
          onRowCountChanged: scope.onRowCountChanged,
          onSelectedRowsChanged: function (args, items) {
            $('.btn-group').removeClass('open');
            scope.onSelectedRowsChanged(args, items);
          },
          onClick: function (item, targetClasses, target, args) {
            $('.btn-group').removeClass('open');
            scope.onRowClick(item, targetClasses, {isCheckBoxColumn: args.cell == 0});
          },
          //rowMetadataProvider: rowMetadataProvider,
          filterFn: scope.filter,
          data: [],
          includeSelectCheckbox: true
        };

        _.each(scope.customUserFields, function (field) {
          var fieldId = 'customField' + field.fieldIndex;
          gridColumns.push({
            id: fieldId,
            name: _.escape(field.name),
            field: fieldId,
            minWidth: 150,
            headerCssClass: "header-column",
            sortable: true,
            toolTip: field.name
          });
        });

        if (needsResize())
          $(window).on('resize', forceOnlyGridResize);


        function needsResize() {
          return $window.BrowserDetect.browser == 'Explorer' && $window.BrowserDetect.version == 9;
        }

        // Iverson -- Not used
        scope.getGridAdditionalStyles = function () {
//          if(scope.showGridHorizontalScroll)
//            return "enableHorizontalScroll";
//          return "";
        };

        // Iverson -- Not used
        scope.updateAfterSideBarHidden = function () {
//          scope.showGridHorizontalScroll = false;
//          if(scope.waitForUserSidebar) {
//            scope.waitForUserSidebar('.user-sidebar:hidden', 30, 100, forceResizeGrid);
//          }
        };

        scope.openSingleUserDetailsSidebar = function () {
          scope.changeSidebar('pages/users/userDetailsSidebar.html');
          scope.selectedUserTabSelected = 'courses';
        };

        scope.openMultiUserDetailsSidebar = function () {
          scope.updateAfterSideBarShown();
          scope.changeSidebar('pages/users/multiUserDetailsSidebar.html');
        };

        // Iverson -- Not used
        scope.updateAfterSideBarShown = function () {
//          $(window).trigger('resize');
//          if(scope.waitForUserSidebar) {
//            scope.waitForUserSidebar('.user-sidebar:visible', 30, 100, function() {
//              scope.showGridHorizontalScroll = true;
//              forceResizeGrid();
//            });
//          }
        };

        // Iverson -- Not used
        function forceResizeGrid() {
//          if(scope.forceGridResize) {
//            scope.forceGridResize();
//            $('.slick-container-footer').trigger('resize');
//          }

          scope.$broadcast('resizeSearch');
        }

        // Iverson -- Not used
        function forceOnlyGridResize() {
//          if(scope.forceGridResize) {
//            scope.forceGridResize();
//          }
        }

        scope.changeSidebar = function (sidebarSrc) {
          scope.sidebarContentSrc = sidebarSrc;
        };

        scope.$watch('sidebarContentSrc', function (newSrc, oldSrc) {
          if (newSrc == oldSrc) {
            return;
          }
          $(window).trigger('resize');
          $timeout(function () {
            scope.forceGridResize();
          });
        });

        scope.showStatusColumn = function () {
          if (!_.any(gridColumns, function (col) {
              return col.id == 'gradeStatus'
            })) {
            gridColumns.splice(1, 0, {
              id: "gradeStatus",
              name: "Status",
              minWidth: 150,
              headerCssClass: "header-column",
              sortable: true,
              sorter: scope.statusColumnSorter,
              formatter: gradeStatusFormatter
            });
            scope.gridCommands.setColumns(gridColumns);
            scope.gridCommands.reSort();
          }
        };

        scope.hideStatusColumn = function () {
          if (_.any(gridColumns, function (col) {
              return col.id == 'gradeStatus'
            })) {
            gridColumns = _.reject(gridColumns, function (col) {
              return col.id == 'gradeStatus'
            });
            scope.gridCommands.setColumns(gridColumns);
          }
        };

        scope.$on('$destroy', function () {
          if (needsResize())
            $(window).off('resize', forceOnlyGridResize);
        });


        function gradeStatusFormatter(row, cell, value, columnDef, item) {
          if (!scope.statusColumnState || !scope.statusColumnState.id)
            return;

          var state = scope.statusColumnState.states[item.id];

          if (state) {
            if (scope.statusColumnState.isCourseStates) {
              return gridFormatters.traineeCourseStatusFormatter(row, cell, value, columnDef, state);
            }
            else {
              return gridFormatters.traineeSeriesStatusFormatter(row, cell, state.status, columnDef, state);
            }
          }
          return "";
        }
      }
    }
  }

})();
